var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 25,
    viewBox: "0 0 14 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0646 14.9346L8.12725 13.2796C7.39463 13.0337 7.39463 11.9641 8.12725 11.7182L13.0646 10.0632C13.3948 9.95303 13.5761 9.58688 13.4682 9.24632L13.084 8.02653C12.9772 7.68597 12.6222 7.499 12.2921 7.61029L7.35471 9.26524C6.62208 9.5112 6.01246 8.64533 6.46455 8.00205L9.51588 3.66937C9.71981 3.38 9.65723 2.97378 9.3767 2.76343L8.37002 2.00886C8.08949 1.79851 7.69566 1.86306 7.49174 2.15243L4.4404 6.48511C3.98724 7.12839 3.00106 6.79785 3.00106 6.00321V0.648845C3.00106 0.290478 2.71944 0 2.37202 0H1.12904C0.781612 0 0.5 0.290478 0.5 0.648845V24.3512C0.5 24.7095 0.781612 25 1.12904 25H2.37309C2.72052 25 3.00213 24.7095 3.00213 24.3512V18.9968C3.00213 18.2022 3.98831 17.8716 4.44148 18.5149L7.49281 22.8476C7.69674 23.1369 8.08948 23.2015 8.3711 22.9911L9.37778 22.2366C9.65831 22.0262 9.72089 21.62 9.51696 21.3306L6.46563 16.998C6.01247 16.3547 6.62208 15.4888 7.35578 15.7348L12.2932 17.3897C12.6233 17.4999 12.9783 17.314 13.0851 16.9735L13.4692 15.7526C13.5761 15.412 13.3959 15.0459 13.0657 14.9357L13.0646 14.9346Z",
    fill: "#00DA93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a55fa47db5544540f8f9327782a45e5b.svg";
export { ForwardRef as ReactComponent };